// extracted by mini-css-extract-plugin
export var breadcrumbs = "navigation-module--breadcrumbs--80ef3";
export var indexWiki = "navigation-module--index-wiki--d64c0";
export var tableOfIndex = "navigation-module--table-of-index--997c8";